import apiServiceNew from './apiService.new';
import {itemsToDisplayPerPage} from '_app/admin/scenes/Campaigns/CampaignDashboard/campaignDashboardConstants';
import {maxTemplatesToDisplay} from '_app/mediahub/scenes/Campaigns/LeadGeneration-Nurturing/leadGenerationNurturingConstants';

const campaignTemplatePath = 'campaignTemplate';

const create = templateInfo => apiServiceNew.post(campaignTemplatePath, templateInfo);

const update = templateInfo => apiServiceNew.put(campaignTemplatePath, templateInfo);

const get = id => apiServiceNew.get(`${campaignTemplatePath}/${id}`);

const remove = campaignId => apiServiceNew.delete(`${campaignTemplatePath}/${campaignId}`);

const getCampaignTemplates = (campaignParams, selectedPage) => {
	const url = `${campaignTemplatePath}/getCampaignTemplates`;

	return apiServiceNew.get(url, {
		params: {
			...campaignParams,
			offset: (selectedPage - 1) * itemsToDisplayPerPage,
			limit: itemsToDisplayPerPage
		}
	});
};

const getPublishedTemplates = (selectedPage, isFavorite, selectedCategory) => {
	const url = `${campaignTemplatePath}/publishedCampaignTemplates`;

	return apiServiceNew.get(url, {
		params: {
			offset: (selectedPage - 1) * maxTemplatesToDisplay,
			limit: maxTemplatesToDisplay,
			isFavorite: isFavorite,
			category: selectedCategory
		}
	});
};

const fetchFavorite = (id, isFavorite) => {

	const url = `${campaignTemplatePath}/favorite?id=${id}&isFavorite=${isFavorite}`;

	return apiServiceNew.put(url);
};

const deleteTile = deleteTileInfo => apiServiceNew.put(`${campaignTemplatePath}/deleteTile`, deleteTileInfo);

export default {
	create,
	get,
	update,
	getCampaignTemplates,
	remove,
	getPublishedTemplates,
	fetchFavorite,
	deleteTile
};